import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { connect } from 'react-redux';
import { RootState } from '../../../app/redux/rootReducer';
import { Coordinator } from '../../../models/coordinator';
import { getCoordinators } from '../../dashboard/redux/organizationSelector';
import { Dispatch } from 'redux';

import { AiOutlineUserAdd } from 'react-icons/ai';
import { MdViewHeadline } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { AppModal, AppTable } from '../../../shared/components';
import AddCoordinatorForm from '../form/AddCoordinatorForm';
import { organizationActions } from '../../dashboard/redux/organizationSlice';
import { appAction } from '../../../app/redux/appSlice';

interface CoordinatorListProps {
  coordinators: Array<Coordinator>;
  fetchCoordinators: () => void;
}

const CoordinatorListPage: React.FC<CoordinatorListProps> = ({
  fetchCoordinators,
  coordinators,
}: CoordinatorListProps) => {
  const [showModal, setShowModal] = useState(false);
  const [refreshState, setRefreshState] = useState(false);
  const dispatch = useDispatch();

  const handleModalToggle = () => {
    setShowModal(!showModal);
  };

  const getCoordinatorTableData = () => {
    const array: Array<JSX.Element> = [];

    {
      coordinators.map((item, i = 1) =>
        array.push(
          <tr>
            <th scope="row">{i + 1}</th>
            <td>{item.coordinatorName}</td>
            <td>{item.coordinatorEmail}</td>
            <td>
              <a href={`tel:${item.coordinatorPhoneNum}`}>
                {item.coordinatorPhoneNum}
              </a>
            </td>
            {/*
            <td>
              <Link
                to={'coordinators/'.concat(item.coordinatorId)}
                className="add-new-link-btn-thin-border ft-size-16"
              >
                <MdViewHeadline size={20} />
              </Link>
            </td>
            */}
          </tr>
        )
      );
    }

    return array;
  };

  useEffect(() => {
    fetchCoordinators();
  }, []);

  const handleOnSuccessCreateCoordinator = () => {
    handleModalToggle();
    setRefreshState(!refreshState);
    fetchCoordinators();
  };

  return (
    <>
      <div className="container pt-3 main-container-div">
        <div>
          <div className="row">
            <div className="col-lg-12 d-flex justify-content-end">
              <div>
                <a
                  onClick={handleModalToggle}
                  className="add-new-link-btn ft-size-16"
                >
                  <AiOutlineUserAdd size={18} /> Add Coordinator
                </a>
                <AppModal
                  onClose={handleModalToggle}
                  show={showModal}
                  title="Add Coordinator"
                >
                  <AddCoordinatorForm
                    createCoordinatorSuccessCallBack={
                      handleOnSuccessCreateCoordinator
                    }
                  />
                </AppModal>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="table_outer_div">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 header-txt">
                    <h5>COORDINATOR LIST</h5>
                  </div>
                </div>
              </div>

              <AppTable
                head={['', 'Name', 'Phone Number', 'Email']}
                data={getCoordinatorTableData()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  coordinators: getCoordinators(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchCoordinators: () => {
    dispatch(organizationActions.fetchCoordinatorList());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoordinatorListPage);
